(function(){
  var KL="VMPTbw", LIST_EMAIL="WnPVDC", LIST_SMS="VQs9np", REV="2026-07-15";
  var form=document.getElementById("fsbq-form");
  if(!form) return;
  var cards=Array.prototype.slice.call(form.querySelectorAll(".fsbq-card"));
  var bar=document.getElementById("fsbq-bar");
  var stepLbl=document.getElementById("fsbq-step");
  var answers={}, idx=0, local="";

  function show(n){
    if(n<0||n>=cards.length) return;
    cards[idx].hidden=true;
    idx=n;
    cards[idx].hidden=false;
    bar.style.width=Math.round(((idx+1)/cards.length)*100)+"%";
    stepLbl.textContent = (idx===cards.length-1) ? "Done" : ("Question "+(idx+1)+" of "+(cards.length-1));
    var y=form.getBoundingClientRect().top+window.pageYOffset-90;
    window.scrollTo({top:y,behavior:"smooth"});
  }

  cards.forEach(function(card){
    var type=card.getAttribute("data-type");
    var key=card.getAttribute("data-key");

    Array.prototype.forEach.call(card.querySelectorAll(".fsbq-opt"), function(btn){
      btn.addEventListener("click", function(){
        if(btn.classList.contains("fsbq-local")){
          Array.prototype.forEach.call(card.querySelectorAll(".fsbq-local"), function(b){ b.classList.remove("on"); });
          btn.classList.add("on");
          local=btn.getAttribute("data-v");
          return;
        }
        if(type==="single"){
          Array.prototype.forEach.call(card.querySelectorAll(".fsbq-opt"), function(b){ b.classList.remove("on"); });
          btn.classList.add("on");
          answers[key]=btn.getAttribute("data-v");
          setTimeout(function(){ show(idx+1); },180);
        } else {
          btn.classList.toggle("on");
          var picked=[];
          Array.prototype.forEach.call(card.querySelectorAll(".fsbq-opt.on"), function(b){ picked.push(b.getAttribute("data-v")); });
          answers[key]=picked;
        }
      });
    });

    var next=card.querySelector(".fsbq-next");
    if(next) next.addEventListener("click", function(){
      if(type==="text") answers[key]=(document.getElementById("fsbq-bike").value||"").trim();
      if(type==="textarea") answers[key]=(document.getElementById("fsbq-note").value||"").trim();
      show(idx+1);
    });

    var back=card.querySelector(".fsbq-back");
    if(back) back.addEventListener("click", function(){ show(idx-1); });
  });

  function normPhone(v){
    var d=(v||"").replace(/[^0-9]/g,"");
    if(d.length===10) return "+1"+d;
    if(d.length===11 && d.charAt(0)==="1") return "+"+d;
    return "";
  }

  /* Klaviyo's own onsite SDK is already loaded on every page of this store.
     It is the primary write path: same-origin to Klaviyo's tracking endpoints,
     no CORS surface, and it works even if the client REST API changes shape.
     The /client/subscriptions/ calls below are secondary and only handle list
     consent -- if they ever fail the profile and all its answers are still
     captured by identify + track. */
  function sdkReady(){
    return typeof window.klaviyo !== "undefined" &&
           typeof window.klaviyo.identify === "function" &&
           typeof window.klaviyo.track === "function";
  }

  function subscribe(listId, profileAttrs){
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+KL, {
      method:"POST",
      headers:{"content-type":"application/json","revision":REV},
      body:JSON.stringify({data:{type:"subscription",
        attributes:{custom_source:"Rider Profile Questionnaire",
          profile:{data:{type:"profile",attributes:profileAttrs}}},
        relationships:{list:{data:{type:"list",id:listId}}}}})
    }).catch(function(){ return null; });
  }

  document.getElementById("fsbq-submit").addEventListener("click", function(){
    var btn=this;
    var err=document.getElementById("fsbq-err");
    var email=(document.getElementById("fsbq-email").value||"").trim();
    var first=(document.getElementById("fsbq-first").value||"").trim();
    var last=(document.getElementById("fsbq-last").value||"").trim();
    var phone=normPhone(document.getElementById("fsbq-phone").value);
    var sms=document.getElementById("fsbq-sms").checked;

    err.hidden=true;
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){
      err.textContent="We need a valid email address to send your results.";
      err.hidden=false; return;
    }
    if(!local){
      err.textContent="Let us know whether you're near Prineville, so we know if the inspection applies.";
      err.hidden=false; return;
    }

    btn.disabled=true; btn.textContent="Sending...";

    var props={};
    Object.keys(answers).forEach(function(k){
      var v=answers[k];
      if(Object.prototype.toString.call(v)==="[object Array]") v=v.join(", ");
      if(v !== "" && v !== undefined) props[k]=v;
    });
    props["Near Prineville"]=local;
    props["Inspection Eligible"]=(local==="Yes");
    props["SMS Opt In"]=!!(sms&&phone);
    props["Rider Profile Completed"]=new Date().toISOString();

    var ident={ $email:email, properties:props };
    if(first) ident.$first_name=first;
    if(last)  ident.$last_name=last;
    if(phone) ident.$phone_number=phone;

    if(sdkReady()){
      try{ window.klaviyo.identify(ident); }catch(e){}
      try{ window.klaviyo.track("Rider Profile Submitted", props); }catch(e){}
    }

    var base={email:email};
    if(first) base.first_name=first;
    if(last)  base.last_name=last;

    var jobs=[ subscribe(LIST_EMAIL, base) ];
    if(sms && phone){
      var withPhone={email:email, phone_number:phone};
      jobs.push(subscribe(LIST_SMS, withPhone));
    }

    var finished=false;
    var done=function(){ if(!finished){ finished=true; finish(first); } };
    Promise.all(jobs).then(done, done);
    /* Never leave someone staring at a spinner because a network call hung. */
    setTimeout(done, 4000);
  });

  function finish(first){
    var h=document.getElementById("fsbq-done-h");
    var b=document.getElementById("fsbq-done-body");
    var hi=first?(", "+first):"";
    var html="";
    if(local==="Yes"){
      h.textContent="Your free inspection is reserved"+hi+".";
      html+="<p>We'll email you within a day or two to book a time. Bring the bike to the shop in Prineville — it takes about half an hour and you'll leave with a written sheet of what we found.</p>";
      html+="<p>We're also putting together a pre-ride checklist for your bike from what you told us.</p>";
    } else {
      h.innerHTML="Thanks"+hi+" — that's genuinely useful.";
      html+="<p>You're outside our neighbourhood, so the in-person inspection isn't much use to you — but we'll email you the <strong>pre-ride checklist for your bike</strong> instead, built from what you just told us.</p>";
      html+="<p>And your answers feed straight into what we decide to stock. That part counts wherever you are.</p>";
    }
    html+="<p style=\"color:#8d8d92;font-size:14px\">Questions in the meantime: <a href=\"mailto:admin@factorysuperbike.com\" style=\"color:#D91E18\">admin@factorysuperbike.com</a></p>";
    b.innerHTML=html;
    show(cards.length-1);
  }
})();